import React, { useState } from 'react';
import Resizing from '../components/Resizing';
import styled, { css } from 'styled-components';
import Select from '../components/Select';
import ImageUploadButton from '../components/ImageUploadButton';
import Caption from '../components/Caption';
import SectionTitle from '../components/SectionTitle';
import Simulation from '../components/Simulation';
import sizeUtil from "../util/Util.js";

const FlexWrapper = styled.div`
    display: flex;
    align-items: stretch;
    justify-content: stretch;
    height: 100%;
    width: 100%;
`;

const LeftSide = styled.div`
        perspective:${p => sizeUtil(p.space).perspective}px;
        perspective-origin:${p => sizeUtil(p.space).perspectiveOrigin};
        display: flex;
        justify-content: center;
        align-items: center;
        overflow:hidden;
        position:relative;
        flex-grow:1;
        background-color: #e8e8e8;
        display: flex;
        justify-content: center;
        align-items: center;
        font-family: 'Noto Sans KR', sans-serif;
        font-size: 28px;
        font-weight: 500;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.43;
        letter-spacing: -0.7px;
        text-align: center;
        color: #a2a2a2;
        flex-direction: column;
    `;

const RightSide = styled.div`
        width:440px;
        box-sizing:border-box;
        flex-shrink:0;
        background-color: #fff;
        padding:45px;
        & h1{
            font-family: 'Noto Sans KR', sans-serif;
            font-size: 24px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            line-height: 1.21;
            letter-spacing: normal;
            text-align: center;
            color: #000;
            margin-bottom: 17px;
        }
    `;

const Section = styled.div`
        padding:12px 0;
        .space-between{
            display: flex;
            justify-content:space-between;
            .sample-indexes{
                margin-left:21.2px;
                img{
                    margin-bottom:13px;
                    height:37px;
                }
                button{
                    margin:0;
                    box-sizing: border-box;
                }
            }
        }
    `;

const GrayBlock = styled.div`
    width: 351px;
    margin: 14px 0;
    padding:28px;
    box-sizing:border-box;
    display:flex;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 15px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: center;
    color: #a2a2a2;
    justify-content: center;
    align-items: center;
    border-radius: 5px;
    background-color: #f2f2f2;
`;

const Button = styled.button`
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 16px;
    padding:12px;
    border:0;
    font-weight: 400;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: center;
    color: #fff;
    cursor: pointer;
    background-color:${props => {
        switch (props.bgColor) {
            case "red":
                return "#a72b2a";
            default:
                return "#8d8d8d";
        }
    }};
    ${({ type }) => type === "red" && css`
        display: flex;
        align-items: center;
        justify-content: center;
        width:140px;
        border-radius: 100px;
        border: solid 1px #a72b2a;
        background-color: #fff;
        font-size: 12px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.42;
        letter-spacing: normal;
        text-align: center;
        color: #a72b2a;
        height:32px;
    `}
`;

const ButtonWrap = styled.div`
    display:flex;
    justify-content: stretch;
    align-items: stretch;
    margin-right:-14px;
    & button{
        flex-shrink: 0;
        flex-grow: 1;
        flex-basis: 0;
        margin-right:14px;
    }
`;

const PatternImageBtn = styled.button`
    display: inline-block;
    margin:unset;
    margin-right: 15.5px;
    padding:0;
    border:unset;
    background-color: unset;
    cursor:pointer;
    &.selected{
        position:relative;
        box-sizing:border-box;
        border: solid 2px #a72b2a;
        background-color: rgba(167, 43, 42, 0.1);
        &::after{
            content:"";
            position:absolute;
            left:0;
            right:0;
            top:0;
            bottom:0;
            background-image: url("comp-img/replay.png");
            background-position: 50% 55%;
            background-repeat: no-repeat;
            background-size: 50%;
        }
    }
`;
const PatternImage = styled.img`
    display: block;
    width:auto;
    height:78.5px;
    margin:0;
`;

const SpaceBtnStyled = styled.button`
    position:relative;
    margin-right: 20px;
    background:none;
    border:none;
    font-family: 'Noto Sans KR', sans-serif;
    font-size: 13px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.38;
    letter-spacing: normal;
    text-align: center;
    color: #494949;
    cursor: pointer;
    img{
        width: 76.8px;
        height: 76.8px;
        border-radius: 999px;
        border:1px solid #ccc;
    }
    & .thumb{
        margin-bottom: 10px;
        position:relative;
    }
    &.selected{
        color:#a72b2a;
        & .thumb::after{
            content:"";
            display:block;
            position:absolute;
            left:-7px;
            top:-7px;
            right:-6px;
            bottom:-4px;
            border-radius: 999px;
            box-sizing:border-box;
            border:2px solid #a72b2a;
        }
    }
`;

function SpaceBtn({ space, children, onClick, className }) {
    return <SpaceBtnStyled onClick={onClick} className={className}>
        <div className="thumb"><img src={`space/${space} 샘플.png`}></img></div>
        <div>{children}</div>
    </SpaceBtnStyled>;
}

function Main() {
    const initialSelectState = {

    };
    const initialFileState = {
        file: null,
        fileUrl: null,
    };
    const initialPatternState = {
        idx: null,
        name: null,
    };
    const [selects, setSelects] = useState(initialSelectState);
    const [space, setSpace] = useState(null);
    const [size, setSize] = useState(null);
    const [file, setFile] = useState(initialFileState);
    const [pattern, setPattern] = useState(initialPatternState);

    return (
        <Resizing wh={{ w: 1920, h: 995 }}>
            <FlexWrapper>
                <LeftSide space={space} className="left-side">
                    {file.fileUrl && selects[0] && selects[1] && pattern.idx !== null ?
                        <Simulation space={space} fileUrl={file.fileUrl} patternName={pattern.name} size={size}></Simulation> :
                        <>
                            <div style={{ marginBottom: 26 }}>
                                <img style={{
                                    width: "50%",
                                    height: 'auto',
                                }} src="comp-img/main_icon_1.png" alt="" />
                            </div>
                            옵션을 선택하고<br />
                            직접 공간을 시뮬레이션 해보세요.<br />
                            <p style={{ margin: 0, marginTop: 5, fontSize: "50%" }}>
                                최신 크롬브라우저 사용을 권장드립니다<br />
                                Windows OS 10 / MAC OS 10.11 버전에서 지원합니다.
                            </p></>}
                </LeftSide>
                <RightSide>
                    <h1>시뮬레이션 시작하기</h1>

                    <Section >
                        <SectionTitle idx={0}>이미지 업로드</SectionTitle>
                        <div>
                            <Caption>
                                {/* *제품이미지는 인덱스 페이지에서 <a style={{ color: '#007fff' }} rel="noreferrer" target="_blank" href="https://b2blxcatalog.com/mobile/product/?p_url=product_4">다운</a> 가능합니다.<br/> */}
                                제품이미지는 1MB 이하 사용을 권장드립니다.
                            </Caption>
                            <div className='space-between'>
                                <ImageUploadButton fileUrl={file.fileUrl} fileCallBack={(file) => {
                                    const fileUrl = file ? URL.createObjectURL(file) : null;
                                    setFile({
                                        file: file,
                                        fileUrl: fileUrl,
                                    });
                                }} XBtnCallBack={() => {
                                    setFile(initialFileState);
                                }}></ImageUploadButton>
                                <div className='sample-indexes'>
                                    <img src="comp-img/sampleindex.png" />
                                    <Button type="red" onClick={() => {
                                        window.open("https://b2bzincatalog.com/product/?p_url=product_4");
                                    }}>
                                        B2B 제품 인덱스 &gt;
                                    </Button>
                                </div>
                            </div>
                        </div>
                    </Section>

                    <Section >
                        <SectionTitle idx={1}>제품 선택</SectionTitle>
                        <div>
                            <Select id={1} placeholder={"제품을 선택해주세요."} options={["Plank", "Square"]} value={selects[0] || ""} selectCallback={(e, x, i) => {
                                setSelects({
                                    ...selects,
                                    0: x,
                                    1: null,
                                });
                                setPattern({});
                            }} />
                            {(selects[0]) ?
                                <div>{(() => {
                                    let arr = [];
                                    switch (selects[0]) {
                                        case "Plank":
                                            arr = ["plank1", "plank2", "herringbone"]
                                            break;
                                        case "Square":
                                            arr = ["square1", "square2"]
                                            break;
                                        default:
                                            break;
                                    }
                                    return arr.map((x, i) =>
                                        <PatternImageBtn
                                            key={i}
                                            onClick={(e) => {
                                                e.preventDefault();
                                                setPattern({ ...pattern, idx: i, name: x })
                                                setSelects({
                                                    ...selects,
                                                    1: false,
                                                });
                                                setSize(null);
                                            }}
                                            className={i === pattern.idx ? "selected" : null}>
                                            <PatternImage src={"img/" + x + ".svg"} />
                                        </PatternImageBtn>)
                                })()}</div>
                                :
                                <GrayBlock>제품을 선택하고<br />
                                    직접 바닥을 시공해보세요.</GrayBlock>
                            }
                        </div>
                    </Section>

                    <Section >
                        <SectionTitle idx={2}>규격 선택</SectionTitle>
                        <div>
                            {(selects[0] && pattern.name) ?
                                <Select id={1} placeholder={"규격을 선택해주세요."} options={(() => {
                                    switch (pattern.name) {
                                        case "plank1":
                                        case "plank2":
                                            return ["150X1200", "180X920", "180X1200"];
                                        case "herringbone":
                                            return ["150X1200", "180X1200"];
                                        case "square1":
                                            return ["450X450", "500X500", "600X600"];
                                        case "square2":
                                            return ["300X600"];
                                        default:
                                            return []
                                    }
                                })()} value={selects[1] || ""} selectCallback={(e, x, i) => {
                                    setSelects({
                                        ...selects,
                                        1: x,
                                    });
                                    setSize(x);
                                }} />
                                :
                                <GrayBlock>STEP2를 진행해주세요.</GrayBlock>
                            }
                        </div>
                    </Section>

                    <Section >
                        <SectionTitle idx={3}>공간 선택</SectionTitle>
                        <Select id={3} placeholder={"공간을 선택해주세요."} options={["의료", "교육", "사무", "판매", "주거"]} value={selects[2] || ""} selectCallback={(e, x, i) => {
                            setSelects({
                                ...selects,
                                2: x,
                            });
                        }} />
                        <div>
                            {(selects[2]) ? <div style={{ display: "flex" }}>
                                {(() => {
                                    let list = [];
                                    switch (selects[2]) {
                                        case "교육":
                                            list = [
                                                {
                                                    slug: "library",
                                                    name: "교육 A"
                                                },
                                                {
                                                    slug: "hallway",
                                                    name: "교육 B"
                                                },
                                                {
                                                    slug: "hallway",
                                                    name: "교육 C"
                                                }
                                            ];
                                            break;
                                        case "의료":
                                            list = [
                                                {
                                                    slug: "hospital-hallway",
                                                    name: "의료 A"
                                                },
                                                {
                                                    slug: "sick-room",
                                                    name: "의료 B"
                                                },
                                                {
                                                    slug: "sick-room",
                                                    name: "의료 C"
                                                },
                                            ];
                                            break;
                                        case "사무":
                                            list = [
                                                {
                                                    slug: "office",
                                                    name: "사무 A"
                                                },
                                                {
                                                    slug: "office-meeting-room",
                                                    name: "사무 B"
                                                },
                                                {
                                                    slug: "office-meeting-room",
                                                    name: "사무 C"
                                                },
                                            ];
                                            break;
                                        case "판매":
                                            list = [
                                                {
                                                    slug: "cafe",
                                                    name: "판매 A"
                                                },
                                                {
                                                    slug: "store",
                                                    name: "판매 B"
                                                },
                                                {
                                                    slug: "store",
                                                    name: "판매 C"
                                                }
                                            ];
                                            break;
                                        case "주거":
                                            list = [
                                                {
                                                    slug: "bedroom",
                                                    name: "주거 A"
                                                },
                                                {
                                                    slug: "dining-room",
                                                    name: "주거 B"
                                                },
                                                {
                                                    slug: "dining-room",
                                                    name: "주거 C"
                                                },
                                            ];
                                            break;
                                        default:
                                            break;
                                    }
                                    return (list.map((x) => <SpaceBtn space={x.name} onClick={(e) => {
                                        e.preventDefault();
                                        if (space === x.name) {
                                            setSpace(null);
                                            return;
                                        };
                                        setSpace(x.name);
                                    }} className={space === x.name ? "selected" : null}>{x.name}</SpaceBtn>))
                                        ;
                                })()}
                            </div>
                                :
                                <GrayBlock>공간을 선택하고<br />
                                    직접 바닥을 시공해보세요.</GrayBlock>
                            }
                        </div>
                    </Section>

                    <ButtonWrap>
                        <Button onClick={() => {
                            setSelects(initialSelectState);
                            setSpace(null);
                            setSize(null);
                            setPattern(initialPatternState);
                            setFile(initialFileState);
                        }}>다시하기</Button>
                    </ButtonWrap>
                </RightSide>
            </FlexWrapper>
        </Resizing >
    );
}

export default Main;